var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{ref:"iframe",staticClass:"hierarchy-iframe",attrs:{"src":_vm.iframeURL}})])}
var staticRenderFns = []

export { render, staticRenderFns }